<template>
  <div class="pa-4">
    <v-card-actions v-if="!isSmallerDisplay()">
      <v-switch v-model="byClassFilter" :label="$t('message.group_classes')"></v-switch>
      <v-spacer></v-spacer>
      <v-btn outlined elevation="0" small color="primary" @click="manualCheckinDialog = true">
        {{ $t('message.manual_checkin') }}
      </v-btn>
    </v-card-actions>
    <v-card-text v-else class="text-center">
      <v-btn outlined elevation="0" block small color="primary" @click="manualCheckinDialog = true">
        {{ $t('message.manual_checkin') }}
      </v-btn>
      <v-card-actions>
        <v-switch v-model="byClassFilter" :label="$t('message.group_classes')"></v-switch>
        <v-spacer></v-spacer>
        <v-btn icon @click="refresh()">
          <v-icon :class="loading ? 'rotate' : ''">mdi-sync</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card-text>
    <div v-if="lastCheckins">
      <v-list v-if="!byClassFilter">
        <template v-for="(c) in lastCheckins">
          <UserCheckin v-if="c" :level-up="displayLevelUp" :display-alerts="displayAlertsDialog" :c="c"
            :key="c._id + 'checkin_by_group'">
          </UserCheckin>
        </template>
      </v-list>
      <v-list v-else>
        <v-list-group :key="'class_grouping_' + classIndex" v-for="(className, classIndex) in lastCheckinClasses"
          :value="true">
          <template v-slot:activator>
            <v-list-item-title>{{ className && className != '' ? className : $t('message.no_class') }} <span
                class="ml-1">({{ lastCheckinsByClass[className] ? lastCheckinsByClass[className].total : 0 }})</span>
            </v-list-item-title>
          </template>
          <div v-if="lastCheckinsByClass[className]">
            <template v-for="(c) in lastCheckinsByClass[className].checkins">
              <UserCheckin v-if="c" :level-up="displayLevelUp" :display-alerts="displayAlertsDialog" :hide-class="true"
                :c="c" :key="c._id + 'checkin_by_group_appending'">
              </UserCheckin>
            </template>
          </div>
        </v-list-group>
      </v-list>
    </div>
    <div v-if="loading" class="text-center">
      <v-skeleton-loader type="article, divider, article"></v-skeleton-loader>
    </div>
    <v-dialog v-model="alertsDialog">
      <v-card class="pa-2">
        <v-card-actions v-if="selectedCheckin && selectedCheckin.instanceId">
          <v-btn color="primary" outlined block @click.stop="displayLevelUp(selectedCheckin)">
            <v-icon>mdi-chevron-double-up</v-icon>
            {{ $t('message.level_up') }}
          </v-btn>
        </v-card-actions>
        <v-card-text v-if="loadingAlerts" class="text-center pa-2">
          <circles-loader />
        </v-card-text>
        <member-alerts v-else :member="memberId" class="bjjlink-card" :alerts="alerts"></member-alerts>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small elevation="0" color="secondary" @click="closeAlertsDialog()">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="manualCheckinDialog" max-width="80%">
      <v-card class="text-xs-left">
        <v-card-title>
          <span>
            <b>{{ $t("message.manual_checkin") }}</b>
          </span>
        </v-card-title>
        <v-card-text>
          <v-autocomplete :disabled="selectedCheckinVisitor != null" v-model="selectedCheckinMember" :items="members"
            :label="$t('message.pick_member')" item-text="text" item-value="value" clearable outlined
            dense></v-autocomplete>
          <v-autocomplete :disabled="selectedCheckinMember != null" v-if="visitors" v-model="selectedCheckinVisitor"
            :items="visitors" :label="$t('message.pick_visitor')" item-text="text" item-value="value" clearable outlined
            dense></v-autocomplete>
          <v-autocomplete v-model="selectedCheckinClass" :items="availableCheckinClasses" item-text="text"
            :label="$t('message.pick_class')" item-value="value" clearable outlined dense></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="processingCheckin"
            :disabled="!selectedCheckinClass || (!selectedCheckinMember && !selectedCheckinVisitor)" outlined
            color="primary" @click="processManualCheckin()">{{
              $t("message.confirm")
            }}</v-btn>
          <v-btn outlined @click="manualCheckinDialog = false">{{
            $t("message.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assignLevelDialog" max-width="80%">
      <v-card class="text-xs-left" v-if="selectedCheckin" elevation="0" outlined>
        <v-card-text>
          <div class="mb-1">
            <div class="text-subtitle-1" v-if="!selectedCheckin.nextLevel">
              {{ $t('message.no_next_level_available') }}
            </div>
            <div v-else class="text-subtitle-1">
              {{ $t('message.suggested_next_level') }}:
            </div>
          </div>
          <div>
            <v-switch v-if="selectedCheckin.isMinor" v-model="selectedCheckin.useMonthlySystem"
              :label="$t('message.kids_monthly_system')"></v-switch>
          </div>
          <BeltSelectMonthly v-if="selectedCheckin.useMonthlySystem" :belts="selectedCheckin.availableLevels"
            v-model="selectedCheckin.nextLevel">
          </BeltSelectMonthly>
          <BeltsSelect v-else-if="selectedCheckin.useBelts" :belts="selectedCheckin.availableLevels"
            v-model="selectedCheckin.nextLevel">
          </BeltsSelect>
          <v-autocomplete outlined v-else v-model="selectedCheckin.nextLevel" :items="selectedCheckin.availableLevels"
            :label="$t('message.select_level')" clearable></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="selectedCheckin.updating" outlined small elevation="0" color="primary"
            @click="assignLevel()">{{
              $t("message.update")
            }}</v-btn>
          <v-btn small elevation="0" @click="assignLevelDialog = false; selectedCheckin = null">{{
            $t("message.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import MemberAlerts from "@/components/displays/MemberAlertsDisplay.vue";
import UserCheckin from "@/components/displays/UserCheckinDisplay.vue";
import BeltSelectMonthly from "@/components/inputs/BeltSelectMonthly.vue";
import BeltsSelect from "@/components/inputs/BeltsSelectStripes.vue";
import Api from "@/services/Api2";


export default {
  data() {
    return {
      loading: true,
      from: null,
      manualCheckinDialog: false,
      selectedCheckinClass: null,
      availableCheckinClasses: null,
      selectedCheckinMember: null,
      selectedCheckinVisitor: null,
      selectedCheckin: null,
      assignLevelDialog: null,
      members: [],
      schedule: null,
      processingCheckin: false,
      avatarSize: 256,
      lastCheckins: [],
      lastCheckinsByClass: {},
      lastCheckinClasses: [],
      intervalChecker: null,
      alertsDialog: false,
      newCheckin: null,
      transitioning: false,
      memberId: null,
      alerts: [],
      exclude: [],
      byClassFilter: true,
      loadingAlerts: false,
      topCheckin: null,
      classesMap: {},
      useSyllabusRanks: false,
      working: false,
      visitors: [],
    };
  },
  components: {
    UserCheckin,
    CirclesLoader,
    MemberAlerts,
    BeltSelectMonthly,
    BeltsSelect
  },
  created() {
    const from = new Date();
    const vm = this;
    this.loadMembers();
    this.loadCheckinClasses();
    from.setHours(0);
    from.setMinutes(0);
    from.setSeconds(0);
    this.from = from;
    if (this.$store.state.selectedAcademy) {
      if (!this.isSmallerDisplay()) {
        this.intervalChecker = setInterval(function () {
          if (vm.$route.path != "/secure/checkins") {
            vm.cancelInterval();
          } else {
            vm.getLastCheckin(true);
          }
        }, 10000);
      }
    }
  },
  mounted() {
    this.getLastCheckin(false);
  },
  watch: {
    byClassFilter: {
      handler: function () {
        this.getLastCheckin(false)
      },
    },
  },
  methods: {
    refresh() {
      this.getLastCheckin(true);
    },
    loadMembers() {
      Api()
        .get("admins/academy/" + this.$store.state.selectedAcademy + "/members")
        .then((response) => {
          const data = response.data;
          if (data) {
            for (const m of data.approved) {
              this.members.push({ value: m._id, text: m.fName + " " + m.lName });
            }
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
      Api()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/visitors?exclude_rejected=true")
        .then((response) => {
          const data = response.data;
          if (data && data.list && data.list.length) {
            for (const v of data.list) {
              if (v && v.user)
                this.visitors.push({ value: v.user._id, text: v.user.displayName });
            }
          }
        });
    },
    processManualCheckin() {
      const checkinData = this.getManualCheckinClassData(this.schedule, this.selectedCheckinClass, this.classesMap);
      if (checkinData) {
        this.processingCheckin = true;
        let className = checkinData.class.name;
        let classDay = checkinData.class.day;
        const professorId = checkinData.professorUser;
        const assistantProfessors = checkinData.assistantProfessors;
        let scheduleClassId = checkinData.class._id;
        const checkinTime = checkinData.checkinTime;
        const data = {
          date: this.dateCheckin,
          member: this.selectedCheckinMember,
          className: className,
          classDay: classDay,
          startTime: checkinData.class.start,
          checkinTime: checkinTime,
          professor: professorId,
          assistantProfessors: assistantProfessors,
          academyClassId: null,
          dayOfMonth: checkinTime.getDate(),
          monthAtCity: checkinTime.getMonth() + 1,
          yearAtCity: checkinTime.getFullYear(),
          scheduleClassId: scheduleClassId
        };
        Api()
          .post(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/checkin/member/" + (this.selectedCheckinMember ? this.selectedCheckinMember : this.selectedCheckinVisitor),
            data
          )
          .then((response) => {
            if (response) this.showAlert("success", this.$t("message.success"));
            this.selectedCheckinMember = null;
            this.selectedCheckinClass = null;
            this.manualCheckinDialog = false;
            this.processingCheckin = false;
          }).catch((e) => {
            if (e)
              this.showAlert("error", "Ops!", this.$t("message.error_generic"));
          });
      }
    },
    goToTransaction(id) {
      this.navigateTo({ name: 'viewtransaction', params: { sessionId: id } });
    },
    loadCheckinClasses() {
      Api()
        .get("admins/academy/" + this.$store.state.selectedAcademy)
        .then((response) => {
          this.classesMap = {};
          let schedule = response.data.schedule;
          this.schedule = schedule;
          let tmp = [];
          for (const d in schedule) {
            for (const c of schedule[d]) {
              var text =
                this.$t("message." + d) + ": " + c.name + " (" + this.numberToTime(c.start) + ")";
              const value = c._id;
              tmp.push({ value: value, text: text, professor: c.professorUser, day: c.day, start: c.start });
            }
          }
          if (tmp.length > 0) {
            const todayClasses = this.getTodaySchedule(tmp);
            if (todayClasses && todayClasses.length) {
              const todaysSchedule = this.$t("message.todays_schedule");
              const schedule = this.$t("message.schedule");
              this.availableCheckinClasses = [];
              this.availableCheckinClasses.push({ header: todaysSchedule });
              this.availableCheckinClasses = this.availableCheckinClasses.concat(todayClasses);
              this.availableCheckinClasses.push({ header: schedule });
              this.availableCheckinClasses = this.availableCheckinClasses.concat(tmp);
            } else {
              this.availableCheckinClasses = tmp;
            }
          }

          //Now add the extra events
          Api()
            .get("calendar/admin/academy/" + this.$store.state.managedAcademy + "/checkins/events")
            .then((response) => {
              const data = response.data;
              if (data) {
                for (const academyClass of data.events) {
                  const text = academyClass.title + " (" + this.$d(new Date(academyClass.date), "month_day", this.$i18n.locale) + ")";
                  this.availableCheckinClasses.push({ value: academyClass.id, text: text, professor: academyClass.professorUser });
                  this.classesMap[academyClass.id] = academyClass;
                }
              }
            })
        });
    },
    closeAlertsDialog() {
      this.alertsDialog = false;
      this.alerts = null;
      this.selectedCheckin = null;
    },
    assignLevel() {
      if (!this.selectedCheckin || !this.selectedCheckin.nextLevel) {
        this.showAlert("error", this.$t('message.assign_next_level'));
        return;
      }
      this.selectedCheckin.updating = true;
      const escapedLevelToAssign = this.selectedCheckin.nextLevel.replace(/\//g, "%2F");
      Api()
        .post("syllabus/academy/" + this.$store.state.managedAcademy + "/instances/" + this.selectedCheckin.instanceId + "/level/" + escapedLevelToAssign)
        .then(response => {
          if (response) {
            this.selectedCheckin = null;
            this.assignLevelDialog = null;
            this.showAlert("success", this.$t('message.updated'));
          }
        })
        .catch(e => {
          console.log(e)
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    displayLevelUp(item) {
      if (!item.instanceId)
        return;
      this.selectedCheckin = item;
      const instanceId = item.instanceId;//item.curriculumInstanceId;
      item.loadingNextLevels = true;
      Api()
        .get(
          "syllabus/managedacademy/" +
          this.$store.state.managedAcademy +
          "/instances/" +
          instanceId +
          "/levels"
        )
        .then((response) => {
          if (response && response.data) {
            this.selectedCheckin.availableLevels = response.data.list;
            this.selectedCheckin.nextLevel = response.data.next;
            this.selectedCheckin.useBelts = response.data.useBelts;
            this.assignLevelDialog = true;
            item.loadingNextLevels = false;
          }
        });
    },
    displayAlertsDialog(item) {
      if (item.user) {
        const id = item.user._id;
        this.memberId = id;
        this.alertsDialog = true;
        this.loadingAlerts = true;
        this.selectedCheckin = item;
        Api()
          .get(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/member/" +
            this.memberId +
            "/alerts"
          )
          .then((response) => {
            if (response && response.data) {
              this.alerts = response.data.alerts;
              this.loadingAlerts = false;
              item.alerts = this.alerts ? this.alerts.length : 0;
            }
          });
      }
    },
    cancelInterval() {
      clearInterval(this.intervalChecker);
    },
    async displayCheckins(checkins, append) {
      if (!append) {
        this.lastCheckinsByClass = {};
        this.lastCheckinClasses = [];
        this.lastCheckins = [];
      }
      let uniqueClassNames = this.lastCheckinClasses;
      for (let c of checkins) {//Only processing new ones
        const memberId = c.user ? c.user._id : null;
        if (memberId && c.member) {
          const response = await Api()
            .get(
              "admins/academy/" +
              this.$store.state.managedAcademy +
              "/member/" +
              memberId +
              "/alerts"
            );
          if (response && response.data) {
            const alertsCount = response.data.alerts ? response.data.alerts.length : 0;
            c.alerts = alertsCount;
            c.alertCounts = response.data.counts;
          }
        }
        //Get alerts and add
        if (this.byClassFilter) {
          const checkedInClassName = this.getClassName(c);
          if (!this.lastCheckinsByClass[checkedInClassName]) {
            this.lastCheckinsByClass[checkedInClassName] = { checkins: [], total: 0 };
            uniqueClassNames.push(checkedInClassName);
          }
          if (append)
            this.lastCheckinsByClass[checkedInClassName].checkins.unshift(c);
          else
            this.lastCheckinsByClass[checkedInClassName].checkins.push(c);
          const total = this.lastCheckinsByClass[checkedInClassName].total + 1;
          this.lastCheckinsByClass[checkedInClassName].total = total;
        } else {
          if (append)
            this.lastCheckins.unshift(c);
          else
            this.lastCheckins.push(c);
        }
      }
      //We need to sort by the hour, in reverse order
      let sortedClassNames = uniqueClassNames;

      sortedClassNames.sort(function (a, b) {
        if (!a || !b)
          return 0;
        const timeA = a.substring(0, 5);
        const timeB = b.substring(0, 5);
        if (timeA.indexOf(':') > 0 && timeB.indexOf(':') > 0) {
          const splitA = timeA.split(':');
          const splitB = timeB.split(':');
          const aHour = new Number(splitA[0] + splitA[1]).valueOf();
          const bHour = new Number(splitB[0] + splitB[1]).valueOf();
          const result = bHour - aHour;
          return result;
        } else {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        }
      });

      //sortedClassNames.sort();
      //sortedClassNames.reverse();

      const noClassTitle = this.$t('message.no_class');
      const noClassIndex = sortedClassNames.indexOf(noClassTitle);
      //remove the noclass from the list
      if (noClassIndex >= 0) {
        sortedClassNames.splice(noClassIndex, 1);
      }
      //Add it again if present
      if (this.lastCheckinsByClass[noClassTitle])
        sortedClassNames.push(noClassTitle);

      this.lastCheckinClasses = sortedClassNames;
      this.loading = false;
      this.working = false;
    },
    getClassName(c) {
      let name = null;
      if (c.name) {
        name = c.name.replaceAll('/', ' ');
        const time = this.numberToTime(c.startTime);
        if (time)
          name = time + ' - ' + name;
      } else {
        name = this.$t('message.no_class')
      }
      return name;
    },
    getLastCheckin(append) {
      if (!this.working) {
        this.working = true;
        if (!append) {
          this.loading = true;
          this.exclude = [];
        }
        Api()
          .post(
            "checkins/academy/" +
            this.$store.state.managedAcademy +
            "/last/checkins",
            { from: this.from, exclude: this.exclude }
          )
          .then((response) => {
            if (response.data && response.data.total > 0) {
              let exclude = new Set(this.exclude);
              for (let c of response.data.checkins) {
                if (c) {
                  c.alerts = null;
                  exclude.add(c._id);
                  if (c.dob)
                    c.daysUntilBirthdate = this.daysUntilBirthDate(c.dob);
                }
              }
              this.useSyllabusRanks = response.data.useSyllabusRanks;
              this.exclude = Array.from(exclude);
              this.displayCheckins(response.data.checkins, append);
            } else {
              this.working = false;
              this.loading = false;
            }
          })
          .catch((e) => {
            console.log(e)
            this.loading = false;
            if (e)
              this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          });
      }
    },
  },
};
</script>

<style scoped></style>
